import React from 'react';
import './FloatingLines.css';

interface FloatingLinesProps {
  className?: string;
  density?: number;
}

const FloatingLines: React.FC<FloatingLinesProps> = ({
  className = '',
  density = 3 // Reduced from 6 to 3
}) => {
  // Create an array of line objects
  const lines = Array.from({ length: density }, (_, index) => {
    // Calculate position and visual properties - more controlled
    const left = 20 + (index * 30); // More evenly distributed
    const top = 20 + (index * 25);
    const width = 50 + (index * 20); // Progressive sizes
    const angle = 15 + (index * 30); // More purposeful angles
    const duration = 20 + (index * 5);
    const delay = index * 2;
    
    return { id: index, left, top, width, angle, duration, delay };
  });

  return (
    <div className={`floating-lines ${className}`}>
      {lines.map(line => (
        <div
          key={line.id}
          className="floating-line"
          style={{
            '--left': `${line.left}%`,
            '--top': `${line.top}%`,
            '--width': `${line.width}px`,
            '--angle': `${line.angle}deg`,
            '--duration': `${line.duration}s`,
            '--delay': `${line.delay}s`
          } as React.CSSProperties}
        ></div>
      ))}
    </div>
  );
};

export default FloatingLines;